import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => {
  return {
    noContentContainer: {
      textAlign: "center",
      marginTop: "8rem",
    },
    noLabel: {
      fontSize: "1.5rem",
      opacity: "0.2",
    },
    athletesContainer: {
      position: "relative",
    },
    sortByContainer: {
      width: "180px",
    },
    rendReportButtonContainer: {
      marginLeft: "10px",
    },
    rendReportButton: {
      textTransform: "capitalize",
    },
    headerContainer: {
      position: "fixed",
      width: "100%",
      zIndex: "1",
    },
    tabsContainer: {
      paddingTop: "15px",
    },
    actionButtonsContainer: {
      position: "fixed",
      marginTop: "-50px",
      right: "20px",
      display: "flex",
      alignItems: "center",
    },
    tabPanelContainer: {
      marginTop: "60px",
    },
    dialogActionsContainer: {
      padding: "15px 20px",
    },
  };
});
